import axios from "axios";
import http from "@/api/http/http";

export default {
  list(params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    const payloadString = Object.entries(params).map(e => e.join('=')).join('&');
    axios.get(`${process.env.VUE_APP_API}/admin/product/list?${payloadString}`, header)
      .then(cb)
      .catch(errCb)
  },
  setDelete (params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.delete(`${process.env.VUE_APP_API}/admin/product/${params.id}`, header)
      .then(cb)
      .catch(errCb)
  },
  data (params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.get(`${process.env.VUE_APP_API}/admin/product/data`, header)
      .then(cb)
      .catch(errCb)
  },
  save (params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios.post(`${process.env.VUE_APP_API}/admin/product`, params, header)
      .then(cb)
      .catch(errCb)
  }
}